'use strict';

angular.module('licensure.internal')
    .controller(
        'InternalTimeoutNotifyController', function ($rootScope, Idle, $uibModal, Enterprise, Session) {
            $rootScope.message = "You are about to be logged out for inactivity.  Interact with the webpage to stay logged in.";
            $rootScope.warningCountdown = 300;
            $rootScope.showCountdown = true;

            Enterprise.getlogoutSettings($rootScope.enterpriseID).then(function (enterprise) {
                if (enterprise != null) { 
                    Idle.setTimeout(enterprise.length);
                    Idle.setIdle((enterprise.session_length - 10) - enterprise.length);
                    $rootScope.message = enterprise.warning_text;
                    $rootScope.warningCountdown = enterprise.length;
                }
                if ($rootScope.authenticatedPage) {
                    Idle.watch();
                } else {
                    Idle.unwatch();
                }
            });
            
            function closeModals() {
                if ($rootScope.warning) {
                    $rootScope.warning.close();
                    $rootScope.warning = null;
                }

                if ($rootScope.timedout) {
                    $rootScope.timedout.close();
                    $rootScope.timedout = null;
                }
            }

            $rootScope.$on('IdleStart', function () {
                closeModals();
                $rootScope.warning = $uibModal.open({
                    templateUrl: paths.app + 'components/timeout-notify/timeout-notify.html',
                    controller: 'InternalTimeoutNotifyModalController',
                    windowClass: 'modal-warning',
                    backdrop: 'static', //This prevents the modal from closing when clicking outside  
                    keyboard: false, //This prevents the modal from closing when pressing ESC
                    resolve: {
                        logout: function () {
                            return function () {
                                Idle.unwatch();
                                closeModals();
                                $rootScope.showCountdown = false;
                                $rootScope.timedout = $uibModal.open({
                                    templateUrl: paths.app + 'components/timeout-notify/timeout-notify.html',
                                    windowClass: 'modal-danger'
                                });
                                window.location = $rootScope.internalURL + "license/controller.cfm?method=SiteController.logout";
                            }
                        },
                        stayLoggedIn: function () {
                            return function () {
                                Idle.watch();
                                Session.checkIn();
                                closeModals();
                            }
                        }
                    }
                });
            });

            $rootScope.$on('IdleTimeout', function () {
                Session.IsSessionAlive().then(function (session) {
                    closeModals();

                    // If session was NOT kept alive by another tab, logout
                    if (!session) {
                        Idle.unwatch();
                        $rootScope.message = "Your Session has expired.  Log back in to continue";
                        $rootScope.showCountdown = false;
                        $rootScope.timedout = $uibModal.open({
                            templateUrl: paths.app + 'components/timeout-notify/timeout-notify.html',
                            windowClass: 'modal-danger'
                        });
                        window.location = $rootScope.internalURL + "license/controller.cfm?method=SiteController.logout";
                    } else {
                        Idle.watch();
                    }
                });
            });

            //Resetting idle time when state is changed
            $rootScope.$on('$stateChangeStart', function () {
                closeModals();

                if ($rootScope.authenticatedPage) {
                    Idle.watch();
                } else {
                    Idle.unwatch();
                }
            });
    })

    .config(function (IdleProvider, KeepaliveProvider) {
        IdleProvider.interrupt('');
        IdleProvider.idle(1200);
        IdleProvider.timeout(300);
        KeepaliveProvider.interval(60);
    })